import React from 'react';
import { DndProvider } from './dnd';
import { SelectedTopLevelIdxsProvider } from './selected-top-level-idxs';
const MarkdownEditorProvider = (props) => {
    return (React.createElement(DndProvider, null,
        React.createElement(SelectedTopLevelIdxsProvider, null, props.children)));
};
export default MarkdownEditorProvider;
//# sourceMappingURL=MarkdownEditorProvider.js.map